// extracted by mini-css-extract-plugin
export default {"dots":"dots_dots__ooI3x","dot":"dots_dot__iuHMd","dotActive":"dots_dotActive__3zKep"};